import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks";

const PrivateRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const { validateAuth } = useAuth();

  useEffect(() => {
    async function checkLoggedIn() {
      const status = await validateAuth();
      setLoggedIn(status);
      setLoading(false);
    }

    checkLoggedIn();
  }, []);

  if (loading) {
    // todo: show loader
    return <div>Loading...</div>;
  }

  return loggedIn ? children : <Navigate to="/login" />;
};
export default PrivateRoute;
